import { formatActionType } from 'app/dealer/shared/higherOrderReducers/withDataRequest/actionTypeFormatters';

import { LEADS_BENCHMARK_REDUCER_NAME } from '../constants';

export const LeadsBenchmarkTimeDivisionActionTypes = {
  SET_TIME_DIVISION: `[${formatActionType(
    LEADS_BENCHMARK_REDUCER_NAME,
  )} TimeDivision] SET_TIME_DIVISION`,
};
